<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container>
        <v-card
          class="rounded-xl tw-min-h-80 "
          v-if="!isProductListLoading"
        >
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div class="tw-mx-2">
              <v-col cols="12">
                <h2 class="tw-font-bold tw-text-base">
                  การแสดงจำนวนรายการเอกสาร
                </h2>
                <v-radio-group
                  :value="pageLimit"
                  column
                  class="tw-inline-block"
                  @change="changeSetting($event, 'pageLimit')"
                  :disabled="loading || userLoading"
                >
                  <v-radio
                    label="แสดงหน้าละ 10 รายการ"
                    color="#6ec39b"
                    value="10"
                  ></v-radio>
                  <v-radio
                    label="แสดงหน้าละ 30 รายการ"
                    color="#6ec39b"
                    value="30"
                  ></v-radio>
                  <v-radio
                    label="แสดงหน้าละ 50 รายการ"
                    color="#6ec39b"
                    value="50"
                  ></v-radio>
                  <v-radio
                    label="อัตโนมัติ"
                    color="#6ec39b"
                    value="auto"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </div>
            <v-row
              align="center"
              justify="center"
              class="tw-mx-2"
              v-if="
                userCompany.isAdmin && !selectedCompanyProductList?.isPdfDoc
              "
            >
              <v-col cols="12">
                <h2 class="tw-font-bold tw-text-base">
                  การส่งอีเมลใบกำกับภาษี / ใบเสร็จรับเงิน
                </h2>
                <v-radio-group
                  :value="sendEmailType"
                  column
                  @change="changeSetting($event, 'sendEmailType')"
                  :disabled="loading || userLoading"
                >
                  <v-radio
                    label="ส่งอีเมลแบบกำหนดเอง"
                    color="#6ec39b"
                    :value="0"
                  ></v-radio>
                  <v-radio
                    label="ส่งอีเมลอัตโนมัติ"
                    color="#6ec39b"
                    :value="1"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              class="tw-mx-2"
              v-if="
                (userCompany.isAdmin || userCompany?.user?.isEngineer)  && !selectedCompanyProductList?.isPdfDoc
              "
            >
              <v-col cols="12">
                <h2 class="tw-font-bold tw-text-base">
                  กำหนดเวลาส่งอีเมลอัตโนมัติ
                </h2>
                <v-label
                  >ส่งอีเมลหลังจากสร้างเอกสาร
                  <div class="auto-mail-time-box">
                    <v-text-field
                      :value="sendEmailDelay"
                      outlined
                      @blur="
                        changeSetting($event.target.value, 'sendEmailDelay')
                      "
                    ></v-text-field>
                  </div>
                  วินาที</v-label
                >
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              class="tw-mx-2"
              v-if="userCompany.isAdmin || userCompany?.user?.isEngineer"
            >
              <v-col cols="12">
                <h2 class="tw-font-bold tw-text-base">
                  สิทธิการเพิ่มผู้ใช้งาน
                </h2>
                <v-radio-group
                  :value="addUserPermission"
                  column
                  @change="changeSetting($event, 'addUserPermission')"
                  :disabled="loading || userLoading"
                  class="tw-inline-block"
                >
                  <v-radio
                    :label="`${selectedCompanyProductList?.isPdfDoc ? 'IT Admin' : 'Owner'} เท่านั้นที่สามารถเพิ่มผู้ใช้งานรายใหม่ได้`"
                    color="#6ec39b"
                    value="owner"
                  ></v-radio>
                  <!-- note: ที่ปิดไว้เพราะตรงนี้ไม่เห็นเอาไปใช้งานต่อ และ ไม่มี role ในระบบ -->
                  <!-- <v-radio
                    label="Owner และ IT admin สามารถเพิ่มผู้ใช้งานรายใหม่ได้"
                    color="#6ec39b"
                    value="owner_and_it"
                  ></v-radio> -->
                </v-radio-group>
              </v-col>
            </v-row>

              <h2 class="tw-font-bold tw-text-base tw-mx-4 tw-mb-4 tw-mt-8">
                จัดการเมนูบาร์บริษัท
                </h2>

              <!-- Company Table -->
              <v-card class="mx-5 elevation-0">
                <v-data-table
                  :headers="headers"
                  :items="companies"
                  :items-per-page="-1"
                  class="company-table"
                >
                  <!-- Logo Column -->
                  <template v-slot:item.logo="{ item }">
                    <v-avatar
                      :color="item.company.imageLogoUrl ? 'transparent' : '#F5F5F5'"
                      size="30"
                      class="mr-3 logo-container"
                    >
                      <img
                        v-if="item.company.imageLogoUrl"
                        :src="getCompanyLogoUrl(item)"
                        :alt="item.company.nameTH"
                        class="company-logo"
                      />
                      <span v-else-if="item.company.nameEN" class="company-initial">
                        {{ getCompanyInitial(item) }}
                      </span>
                    </v-avatar>
                  </template>

                  <!-- Company Name Column -->
                  <template v-slot:item.name="{ item }">
                    {{ item.company.nameTH }}
                  </template>

                  <!-- Visibility Toggle Column -->
                  <template v-slot:item.isVisible="{ item }">
                    <v-switch
                      v-if="companies.length > 1"
                      v-model="companyVisibility[item.id]"
                      @change="handleVisibilityChange(item.id)"
                      color="primary"
                      hide-details
                      class="ma-2"
                      :label="companyVisibility[item.id] ? 'แสดง' : 'ซ่อน'"
                    ></v-switch>
                  </template>
                </v-data-table>
              </v-card>

              <!-- Save Button -->
              <v-row class="mt-4">
                <v-col cols="12" class="text-right">
                  <v-btn color="primary" @click="saveSettings" :loading="isSaving">
                    <v-progress-circular
                      v-if="isSaving"
                      indeterminate
                      color="green"
                      style="margin-right: 10px;"
                    ></v-progress-circular>
                    <v-icon left class="tw-text-2xl">mdi-content-save</v-icon>
                    บันทึกการตั้งค่า
                  </v-btn>
                </v-col>
              </v-row>
          
          </v-card-text>
          <div
            v-else
            class="align-center justify-center"
            style="height: 200px; display: flex"
          >
            No Permission
          </div>
          <!-- selectedCompanyProductList {{selectedCompanyProductList}} -->
        </v-card>
        <v-card v-else class="rounded-xl tw-min-h-80 tw-p-7">
          <v-skeleton-loader
            type="list-item-two-line"
            style="width: 400px;"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="list-item-three-line"
            style="width: 400px;"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="list-item-three-line"
            style="width: 400px;"
          ></v-skeleton-loader>

            
        </v-card>

      </v-container>
    </v-main>
  </Admin>
</template>
<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Board",
  components: {
    Admin,
  },
  computed: {
    ...mapState({
     companies: (state) => state.companies.list,
    user: (state) => state.user.userData,
    loading: (state) => state.companies.loading,
    userLoading: (state) => state.user.loading,
    sendEmailType: (state) => state.companies.sendEmailType,
    addUserPermission: (state) => state.companies.addUserPermission,
    userCompany: (state) => state.user.userCompany,
    selectedCompany: (state) => state.companies.selectedCompany,
    sendEmailDelay: (state) => state.companies.sendEmailDelay,
    selectedCompanyProductList: (state) =>
      state.companies.selectedCompanyProductList,
    isProductListLoading: (state) => state.companies.isProductListLoading,
  }),
  STORAGE_KEY() {
      return this.user?.email ? `companyVisibilitySettings_${this.user.email}` : null;
    },
  },
  created() {
    this.getCompanyDetailSettingAndRoleUser();
    this.getCompanyProductList();
    this.getCompanyList();
  },
  data: () => ({
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "ปรับแต่งบอร์ด",
        disabled: true,
      },
    ],
    pageLimit: localStorage.getItem("pageLimit"),
    headers: [
        { text: 'โลโก้', value: 'logo', sortable: false, width: '80' },
        { text: 'ชื่อบริษัท', value: 'name', sortable: false, width: '400' },
        { text: 'การแสดงผล', value: 'isVisible', sortable: false }
      ],
    companyVisibility: {},
      isSaving: false,
      snackbar: {
        show: false,
        message: '',
        color: '',
      },
  }),
  methods: {
    changeSetting: function (event, type) {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        if (type === "pageLimit") {
          let user = firebase.auth().currentUser;
          this.$store.dispatch(
            "user/updatePageLimitSetting",
            { companyId: companyId, userId: user.uid, pageLimit: event },
            () => {
              this.pageLimit = localStorage.getItem("pageLimit");
            }
          );
        } else {
          this.$store.dispatch("companies/updateCompanySetting", {
            companyId: companyId,
            type: type,
            value: event,
          });
        }
      }
    },
    getCompanyDetailSettingAndRoleUser: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("user/getRoleUser", { companyId: companyId });
        this.$store.dispatch("companies/getCompanyDetailSetting", {
          id: companyId,
        });
      }
    },
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    getDeviceRatio() {
      return window.devicePixelRatio;
    },

    getCompanyLogoUrl(company) {
      return `${company.company.imageLogoUrl}=s${Math.round(30 * this.getDeviceRatio())}`;
    },

    getCompanyInitial(company) {
      return company.company.nameEN?.[0]?.toUpperCase() ?? '';
    },

    getCompanyList() {
      this.$store.dispatch('companies/getList');
    },

    initializeVisibilitySettings() {
      // Only attempt to load settings if STORAGE_KEY is defined
      if (this.STORAGE_KEY) {
        const savedSettings = localStorage.getItem(this.STORAGE_KEY);
        if (savedSettings) {
          this.companyVisibility = JSON.parse(savedSettings);
        } else {
          // Initialize all companies as visible by default for new users
          this.companies.forEach(company => {
            this.$set(this.companyVisibility, company.id, true);
          });
        }
      }
    },

    handleVisibilityChange(companyId) {
      this.$set(this.companyVisibility, companyId, this.companyVisibility[companyId]);
    },

    async saveSettings() {
      try {
        this.isSaving = true;

        // Save to localStorage with user-specific key
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.companyVisibility));

        // Show success snackbar
        this.snackbar = {
          show: true,
          message: 'บันทึกการตั้งค่าเรียบร้อยแล้ว',
          color: 'success',
        };

        // Delay before refreshing to ensure the snackbar is visible briefly
        setTimeout(() => window.location.reload(), 500);

      } catch (error) {
        console.error('Error saving settings:', error);

        // Show error snackbar
        this.snackbar = {
          show: true,
          message: 'เกิดข้อผิดพลาดในการบันทึกการตั้งค่า',
          color: 'error',
        };
      } finally {
        this.isSaving = false;
      }
    },
  },
  watch: {
    companies: {
      handler() {
        // Reinitialize when `companies` data updates
        this.initializeVisibilitySettings();
      },
      immediate: true,
    },
    STORAGE_KEY(newKey) {
      // Reinitialize settings when `STORAGE_KEY` is defined or changes
      if (newKey) {
        this.initializeVisibilitySettings();
      }
    },
  },
};
</script>
<style lang="scss">
.row-detail {
  padding-left: 24px;
}
.auto-mail-time-box {
  display: inline-block;
  width: 100px;
  .v-text-field {
    fieldset {
      border-radius: 10px;
    }
    input[type="text"] {
      text-align: center;
    }
  }
  .v-text-field--outlined fieldset {
    top: 0;
    height: 50px;
  }
}

.company-logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
</style>
